import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import {MyAnimatedTypo,MyAnimatedTypo2} from "../Moving"
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import './Certificazioni.css'
import pdf from "../../Assets/../Assets/PDF_1.pdf";
import pdf_2 from "../../Assets/../Assets/PDF_2.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import imageUrl1 from "../../Assets/PDF_1.png";
import imageUrl2 from "../../Assets/PDF_2.png";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


function ResumeNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  return (
    <div>
  <Container fluid className="home-section" id="certificazioni">
      <Container className="Certificazioni-content"> 
        <Row md={7} className="Certificazioni-header">
          <h1 style={{ paddingTop: 40}}>
           CERTIFICAZIONI
          </h1>
        </Row>
{/*}
        <Row style={{ justifyContent: "center", position: "relative", paddingTop: 30 }}>
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            style={{ maxWidth: "300px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download Diploma A.N.AMM.I
          </Button>
        </Row>
*/}
        <div className= "Certificazioni-image-container"  style={{ paddingTop: 40 }}>
          <img src={imageUrl1} alt= ''/>
        </div>
{/*
        <Row className="Certificazioni" style={{paddingTop: 40}}>
          <Document file={pdf}>
            <Page pageNumber={1} className="Certificazione_pdf" />
          </Document>
        </Row>
*/}
        <Row style={{ justifyContent: "center", position: "relative", paddingTop: 40 }}>
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            style={{ maxWidth: "300px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download Diploma A.N.AMM.I
          </Button>
        </Row>

        <div className= "Certificazioni-image-container"  style={{paddingTop: 40 }}>
          <img src={imageUrl2} alt= '' style={{maxHeight:668,maxWidth:464, margin: "auto"}}/>
        </div>

        <Row style={{ justifyContent: "center", position: "relative", paddingTop: 40 }}>
          <Button
            variant="primary"
            href={pdf_2}
            target="_blank"
            style={{ maxWidth: "300px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download Attestazione A.N.AMM.I
          </Button>
        </Row>

        <br></br>
      </Container>
    </Container>
  </div>
  );
}

export default ResumeNew;
